import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ListaDTO } from '../modules/util/modal-datos/dtos/lista-DTO';
import { TramiteSicCompetenciaDeslealDto } from '../dto/tramites/tramite-sic-competencia-desleal.dto';

@Injectable({
  providedIn: 'root',
})
export class TramiteSicService {
  private apiUrl = environment.apiUrl;
  private baseUrl = '/tramite/registrar-tramite';
  private apiUrlListas = `${environment.apiUrl}/lista`;
  private personaUrl = `${environment.apiUrl}/persona/obtenerPorTipoYNumDocumento`;

  constructor(private http: HttpClient) {}

  crearTramiteCompentenciaDesleal(
    data: TramiteSicCompetenciaDeslealDto
  ): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}${this.baseUrl}`, data);
  }

  // Servicio que obtiene las listas por nombre
  listasValor(nombre: string): Observable<ListaDTO[]> {
    return this.http.get<ListaDTO[]>(
      `${this.apiUrlListas}/listaValor/${nombre}`
    );}

  enviarNotificacion(idTramite: number) {
    return this.http.get<{ data: {}; message: string; success: boolean }>(
      `${this.apiUrl}/tramite/notificar/${idTramite}`
    );
  }
}
